<script>
import {defineComponent} from 'vue';
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
	name: 'BaseModal',
	props: {
		id: {
			type: String,
			required: true,
		},
		classModal: {
			type: String,
			default: '',
		}
	},
    emits: ['close'],
	computed: {
		isOpened() {
			return this.isModalOpened(this.id);
		},
		...mapGetters({
			isModalOpened: 'modals/isModalOpened'
		})
	},
	mounted() {
		try {
			this.registerModal(this.id);
		} catch (error) {
			console.error(error);
		}
	},
	methods: {
		showModal() {
			this.openModal(this.id);
		},
		hideModal() {
            this.$emit('close');
			this.closeModal(this.id);
		},
		...mapActions({
			openModal: 'modals/openModal',
			closeModal: 'modals/closeModal',
			registerModal: 'modals/registerModal',
		})
	},
});
</script>

<template>
	<transition name="modal" :duration="450" appear>
		<dialog
			v-if="isOpened"
			ref="modal"
			class="modal-window"
			:class="classModal"
			:open="isOpened"
			@keydown.esc="hideModal">
			<div class="modal-window__bg"></div>

			<div class="modal-window__body">
				<slot :close="hideModal"></slot>
			</div>
		</dialog>
	</transition>
</template>
